import {
    CHECK_STOCK_REQUEST,
    CHECK_STOCK_SUCCESS,
    CHECK_STOCK_FAILURE
} from "../types/stockTypes";
import { checkStock } from "../../Services/MainServices"; // Import the service

export const checkStockAvailability = (sub_product_id, quantity) => async (dispatch) => {
    dispatch({ type: CHECK_STOCK_REQUEST });

    try {
        const payload = { sub_product_id, quantity };
        const response = await checkStock(payload); // Call the service

        // Explicitly check for response status
        if (response?.status === 200 && response?.data?.status === "success") {
            dispatch({
                type: CHECK_STOCK_SUCCESS,
                payload: response.data, // API response
            });
            return response; 
        } else {
            dispatch({
                type: CHECK_STOCK_FAILURE,
                payload: response?.data?.message || "Stock check failed",
            });
            throw new Error(response?.data?.message || "Stock check failed");
        }
    } catch (error) {
        dispatch({
            type: CHECK_STOCK_FAILURE,
            payload: error.response?.data?.message || "Failed to check stock",
        });
        throw error; // Re-throw the error for further handling
    }
};